import React, {ReactElement} from 'react';
import Accordion, {AccordionStartOpen} from '../Accordion/Accordion';
import {createFlatItems} from '../Accordion/createFlatItems';
import Headers, {HeaderType} from '../Text/Headers/Headers';
import Paragraph from '../Text/Paragraph/Paragraph';
import {Alignment, ContentfulAccordionItem} from '../../../types';

import './AccordionWithTitleAndSubHeading.scss';

interface Props {
  accordionName: string;
  queryItems: ContentfulAccordionItem[];
  subheading?: string;
  startOpen?: AccordionStartOpen;
}

function AccordionWithTitleAndSubHeading({
  queryItems,
  accordionName,
  subheading,
  startOpen,
}: Props): ReactElement | null {
  const flatItems = createFlatItems(queryItems);

  if (flatItems.length === 0) {
    return null;
  }

  return (
    <div className="accordionWithTitleAndSubHeading">
      <Headers
        headerType={HeaderType.H2}
        className="accordionWithTitleAndSubHeading__title"
        alignment={Alignment.CENTER}
      >
        {accordionName}
      </Headers>
      {subheading && (
        <Paragraph alignment={Alignment.CENTER} className="accordionWithTitleAndSubHeading__subtitle">
          {subheading}
        </Paragraph>
      )}
      <Accordion items={flatItems} className="accordionWithTitleAndSubHeading__accordion" startOpen={startOpen} />
    </div>
  );
}

export default AccordionWithTitleAndSubHeading;
